import React from "react"
import PropTypes from "prop-types"
import ErrorText from "@irati/ui/src/ErrorText"
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton"

import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"

const ContinueButton = ({error, disabled, loading, onClick, style, className, buttonText, formatMessage, ...props}) => {
  const text = loading ? formatMessage({id: "perks.continueButton.processing"})
    : (buttonText || formatMessage({id: "perks.continueButton.continue"}))
  return (
    <div className={className}>
      <ValidationButton
        id={id("btn", props)}
        primary
        large
        full
        style={style}
        onClick={onClick}
        disabled={disabled || !!loading}>
        {text}
      </ValidationButton>
      {error &&
        <ErrorText>{error}</ErrorText>
      }
    </div>
  )
}

ContinueButton.defaultProps = {
  id: "continue",
  style: null,
  loading: false,
  disabled: false,
  error: null,
  className: null,
  buttonText: null
}

ContinueButton.propTypes = {
  style: PropTypes.object,
  onClick: PropTypes.func.isRequired,
  formatMessage: PropTypes.func.isRequired,
  loading: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool
  ]),
  disabled: PropTypes.bool,
  error: PropTypes.string,
  className: PropTypes.string,
  buttonText: PropTypes.string
}

export default injectIntl(ContinueButton)
